import {
  IncomingOrganizationMembershipProductCreateDto,
  IncomingOrganizationMembershipProductUpdateDto,
  OutgoingMembershipProductDto
} from 'api/dtos/memberships/products';
import bounceApiClient from 'legacy/common/utils/bounceApiClient';

export async function getOrganizationMemberships(
  organizationId: string
): Promise<OutgoingMembershipProductDto[]> {
  const { data } = await bounceApiClient.get(
    `/api/organizations/${organizationId}/membership-products`
  );
  return data?.products || [];
}

export async function getOrganizationMembership(
  organizationId: string,
  membershipTierId: string
): Promise<OutgoingMembershipProductDto> {
  const { data } = await bounceApiClient.get(
    `/api/organizations/${organizationId}/membership-products/${membershipTierId}`
  );
  return data;
}

export async function updateOrganizationMembership({
  organizationId,
  membershipTierId,
  membershipTier
}: {
  organizationId: string;
  membershipTierId: string;
  membershipTier: IncomingOrganizationMembershipProductUpdateDto;
}): Promise<OutgoingMembershipProductDto> {
  const { data } = await bounceApiClient.patch(
    `/api/organizations/${organizationId}/membership-products/${membershipTierId}`,
    membershipTier
  );
  return data;
}

export async function createOrganizationMembership({
  organizationId,
  membershipTier
}: {
  organizationId: string;
  membershipTier: IncomingOrganizationMembershipProductCreateDto;
}): Promise<OutgoingMembershipProductDto> {
  const { data } = await bounceApiClient.post(
    `/api/organizations/${organizationId}/membership-products`,
    membershipTier
  );
  return data;
}

export async function exportOrganizationMembershipsCSV(
  organizationId: string
): Promise<Blob> {
  const { data } = await bounceApiClient.get(
    `/api/organizations/${organizationId}/memberships/export`,
    { responseType: 'blob' }
  );
  return data;
}
